// extracted by mini-css-extract-plugin
export default {"container":"VideoPopup_container__Ij5UE","video":"VideoPopup_video__s1rb3","closeIcon":"VideoPopup_closeIcon__v2tP0"};